import {
    LANE_DETAILS_YEAR_REQUEST,
    LANE_DETAILS_YEAR_SUCCESS,
    LANE_DETAILS_YEAR_FAILURE
} from '../../actions/marketInsights/laneDetailsYearActions';

interface LaneDetailsYearly {
    yearlyLaneDetails: any;
    isFetching: boolean;
}

const fetchLanesYearReducer = (laneDetailsYearly: LaneDetailsYearly = {
    isFetching: false,
    yearlyLaneDetails: []
}, action: any): LaneDetailsYearly => {
    switch (action.type) {
        case LANE_DETAILS_YEAR_REQUEST: {
            return {
                ...laneDetailsYearly,
                isFetching: true
            };
        }
        case LANE_DETAILS_YEAR_SUCCESS: {
            return {
                ...laneDetailsYearly,
                isFetching: false,
                yearlyLaneDetails: action.payload
            };
        }
        case LANE_DETAILS_YEAR_FAILURE: {
            return {
                ...laneDetailsYearly,
                isFetching: false,
                yearlyLaneDetails: []
            };
        }
        default:
            return laneDetailsYearly;
    }
};

export default fetchLanesYearReducer;
